import React, { useContext } from 'react'
import GameContext from './GameContext';

export default function useGameConfig() {
    const context = useContext(GameContext);
    if (context == null)
        throw new Error('You can only use useGameConfig inside a GameContext')

    return context.gameConfiguration;
}